const proofs=new Map<string,string>();
export function preparationProof(token:string):string{
 if(proofs.has(token))return proofs.get(token)!;
 try{return sessionStorage.getItem('precision.preparation.access.'+token)||'';}catch{return '';}
}
export function savePreparationProof(token:string,proof:string){
 proofs.set(token,proof);
 try{sessionStorage.setItem('precision.preparation.access.'+token,proof);}catch{/* Current tab still works when storage is unavailable. */}
}
